<template>
  <div :class="{ 'damage-readonly': readonly }">
    <div class="text-center">
      <left-vehicle
        v-on:updated="updateLeftDamage"
        :front="car.left_front"
        :frontDoor="car.left_front_door"
        :rearDoor="car.left_rear_door"
        :rear="car.left_rear"
        :frontWheel="car.left_front_wheel"
        :rearWheel="car.left_rear_wheel"
      ></left-vehicle>
    </div>

    <div class="row main-images mt-3 mb-3">
      <div class="col-lg-4 text-center rear">
        <rear-vehicle
          v-on:updated="updateRearDamage"
          :bumper="car.rear_bumper"
          :boot="car.rear_boot"
        ></rear-vehicle>
      </div>

      <div class="col-lg-4 text-center roof">
        <vehicle-roof
          v-on:updated="updateRoofDamage"
          :rearWindscreen="car.rear_windscreen"
          :roof="car.roof"
          :frontWindscreen="car.front_windscreen"
          :bonnet="car.top_bonnet"
        ></vehicle-roof>
      </div>

      <div class="col-lg-4 text-center front">
        <front-vehicle
          v-on:updated="updateFrontDamage"
          :bumper="car.front_bumper"
          :bonnet="car.front_bonnet"
        ></front-vehicle>
      </div>
    </div>

    <div class="text-center">
      <right-vehicle
        v-on:updated="updateRightDamage"
        :front="car.right_front"
        :frontDoor="car.right_front_door"
        :rearDoor="car.right_rear_door"
        :rear="car.right_rear"
        :frontWheel="car.right_front_wheel"
        :rearWheel="car.right_rear_wheel"
      ></right-vehicle>
    </div>

    <div class="mt-3">
      <input-block
        v-model="car.description"
        name="description"
        label="Damage Description"
        helper="Add any additional information details about the vehicle damage here"
      ></input-block>
    </div>
  </div>
</template>
<script>
import Rear from './../Children/Car/Rear.vue';
import Roof from './../Children/Car/Roof.vue';
import Front from './../Children/Car/Front.vue';
import Left from './../Children/Car/Left.vue';
import Right from './../Children/Car/Right.vue';

export default {
  props: {
    car: {
      type: Object,
      required: true
    },
    damage: {
      type: Object
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'rear-vehicle': Rear,
    'vehicle-roof': Roof,
    'front-vehicle': Front,
    'left-vehicle': Left,
    'right-vehicle': Right
  },

  methods: {
    updateFrontDamage(value) {
      let refined = {
        front_bumper: value.bumper,
        front_bonnet: value.bonnet
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateRightDamage(value) {
      let refined = {
        right_front_door: value.frontDoor,
        right_front: value.frontBumper,
        right_rear_door: value.backDoor,
        right_rear: value.rearBumper,
        right_front_wheel: value.frontWheel,
        right_rear_wheel: value.rearWheel
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateLeftDamage(value) {
      let refined = {
        left_front_door: value.frontDoor,
        left_front: value.frontBumper,
        left_rear_door: value.backDoor,
        left_rear: value.rearBumper,
        left_front_wheel: value.frontWheel,
        left_rear_wheel: value.rearWheel
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateRoofDamage(value) {
      let refined = {
        rear_windscreen: value.rearWindscreen,
        roof: value.roof,
        front_windscreen: value.frontWindscreen,
        top_bonnet: value.bonnet
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateRearDamage(value) {
      let refined = {
        rear_bumper: value.bumper,
        rear_boot: value.boot
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateCar(data) {
      setTimeout(() => {
        for (let property in data) {
          if (Object.hasOwn(this.car, property)) {
            this.car[property] = data[property];
          }
        }
      }, 100);
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    }
  },

  watch: {
    damage: {
      handler(damage) {
        if (damage) {
          this.updateCar(damage);
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
.damage-readonly svg {
  pointer-events: none;
}
</style>
